<template>
  <div class="VideoListCard">
    <template v-if="content == ''">
        <div class="null">
            <img src="@/common/images/leveing/video/null.png" alt="直播空">
            <p>暂无内容</p>
          </div>
      </template>
      <template v-else>
        <div v-html="content" class="contentHtml"></div>
      </template>
  </div>
  <!-- end 图文模块 -->
</template>

<script>
export default {
  name: 'VideoListCard',
  props: ['item'],
  data () {
    return {
      content: ''
    }
  },
  mounted () {
    this.content = this.item.content
  },
  methods: {},
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss">
.VideoListCard {
    line-height: 1.5;
    img {
        max-width: 100% !important;
    }
    .null {
      margin-top: 40px;
      img {
        display: block;
        margin: auto;
        margin-top: 30px;
        width: 127px;
        height: 120px;
      }
      p {
        margin-top: 10px;
        font-size: 14px;
        text-align: center;
        color: #999;
      }
    }
    .contentHtml {
        * {
          font-size: 14px;
          color: #999;
          line-height: 20px;
        }
        img {
            max-width: 100%;
            position: relative;
            // line-height: 0;
            vertical-align: middle;
        }
    }
}
</style>